exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-circle {\n  display: block;\n  margin-left: auto;\n  margin-right: auto; }\n\n@media only screen and (max-width: 768px) {\n  .img-circle {\n    width: 140px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/nicholasmurray/Documents/firebase-websites/CommunityAdviceNMD/src/app/components/lazy-image/lazy-image.component.scss
// module id = ../../../../../src/app/components/lazy-image/lazy-image.component.scss
// module chunks = main